import classes from 'components/widgets/ProjectScorecards/components/SubmittedCompletionDurationCell/SubmittedCompletionDurationCell.module.scss';

export const SubmittedCompletionDurationCell = ({ row }) => {
    const submitted_completion = row.original.submitted_completion;
    return (
        <div>
            <div>{submitted_completion?.value}%</div>
            <div className={classes.subAdherence}>{row.original.duration.value} months</div>
        </div>
    );
};
